module.exports = __webpack_public_path__ + "img/Talk Graphic 11 - Plan Writing.2d3b7855.png";